<button
  pButton
  class="my-3"
  (click)="open()"
  i18n="@@createMandant"
>Neuer Mandant</button>
<p-card>
  <p-table
    [value]="(frontendService.results$ | async) ?? []"
    dataKey="_id"
    styleClass="p-datatable-sm"
    selectionMode="single"
    [(selection)]="selectedMandant"
    (onRowSelect)="selectMandantForEdit($any($event.data))"
  >
    <ng-template #header>
      <tr>
        <th pSortableColumn="name">{{getColumnLabel('name')}} <p-sort-icon field="name" /></th>
        <th>{{getColumnLabel('tiles')}}</th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-mandant
    >
      <tr [pSelectableRow]="mandant">
        <td>
          {{mandant.name}}
          <span
            *ngIf="mandant.internal"
            class="mandant-internal-badge"
            i18n="@@layoutInternalBadge"
          >Intern</span>
        </td>
        <td>
          <span
            class="badge mandant-tile-badge m-1 d-inline-flex align-items-center gap-1"
            *ngFor="let tile of mandant.tiles"
          >
            <span
              class="mandant-tile-badge-icon"
              [ngStyle]="{'background-color': getTileById(tile)?.color ?? '#6366f1'}"
            >
              <app-tile-icon [tile]="getTileById(tile)"></app-tile-icon>
            </span>
            {{ getTileById(tile)?.name }}
          </span>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td
          colspan="2"
          i18n="@@mandantAdminNoData"
        >Noch keine Mandanten vorhanden.</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

<p-dialog
  header="Nutzer bearbeiten"
  i18n-header="@@mandantAdminEditUserTooltip"
  [visible]="!!editingGlobalUserId"
  (visibleChange)="!$event && closeUserDialog()"
  [modal]="true"
  appendTo="body"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  [closable]="!globalUserEditor?.embeddedSaving"
  [closeOnEscape]="!globalUserEditor?.embeddedSaving"
  [style]="{width: '880px', maxWidth: '95vw'}"
>
  @if (editingGlobalUserId) {
  <app-global-user-administration
    #globalUserEditor
    [userId]="editingGlobalUserId"
    (userSaved)="onUserSaved()"
  ></app-global-user-administration>
  }
  <ng-template #footer>
    <button
      pButton
      type="button"
      [outlined]="true"
      [disabled]="globalUserEditor?.embeddedSaving"
      (click)="closeUserDialog()"
      i18n="@@globalClose"
    >Schließen</button>
  </ng-template>
</p-dialog>

<p-drawer
  #editMandantDrawer
  [(visible)]="editVisible"
  [closeOnEscape]="!editingGlobalUserId"
  position="right"
  [style]="{width: 'min(880px, 95vw)'}"
  (onHide)="closeEditMandant()"
>
  <ng-template #header>
    <span
      class="fs-6 fw-bold"
      i18n="@@globalEdit"
    >Bearbeiten</span>
  </ng-template>
  <div *ngIf="editMandant">
    <app-form
      #form
      type="edit"
      [data]="editMandant"
      [showActions]="false"
      [formFields]="[
        { fieldName: 'name', type: 'text', required: true},
        { fieldName: 'short', type: 'text', required: true},
        { fieldName: 'internal', type: 'switch'}
      ]"
      [translatedLabels]="translatedLabels"
      (submit)="updateMandant($event)"
    ></app-form>

    <label class="form-label d-block">{{ getColumnLabel('tiles') }}</label>
    <ul class="list-group mb-2">
      <li
        class="list-group-item d-flex justify-content-between align-items-center"
        *ngFor="let tile of getAssignedTiles(editMandant)"
      >
        <span class="d-flex align-items-center gap-2">
          <span
            class="tile-admin-table-icon-badge"
            [ngStyle]="{'background-color': tile.color ?? '#6366f1'}"
          >
            <app-tile-icon [tile]="tile"></app-tile-icon>
          </span>
          {{ tile.name }}
        </span>
        <button
          pButton
          type="button"
          [text]="true"
          severity="danger"
          (click)="removeTileFromMandant(editMandant, tile._id)"
          title="Aus dem Kachel-Pool entfernen"
          i18n-title="@@mandantAdminTilesRemoveTooltip"
        ><i class="ri-close-line"></i></button>
      </li>
      <li
        class="list-group-item text-muted small"
        *ngIf="editMandant.tiles.length === 0"
        i18n="@@mandantAdminTilesEmpty"
      >Der Kachel-Pool ist leer.</li>
    </ul>
    <button
      pButton
      type="button"
      [outlined]="true"
      class="mb-3"
      (click)="editTileMenu.toggle($event)"
      title="Zum Kachel-Pool hinzufügen"
      i18n-title="@@mandantAdminTilesAddTooltip"
    ><i class="ri-add-line"></i></button>
    <p-menu
      #editTileMenu
      [popup]="true"
      [model]="getTileMenuItems(editMandant)"
      appendTo="body"
    >
      <ng-template
        #item
        let-item
      >
        <div class="d-flex align-items-center gap-2 px-3 py-2">
          <span
            class="tile-admin-table-icon-badge"
            [ngStyle]="{'background-color': item.tile.color ?? '#6366f1'}"
          >
            <app-tile-icon [tile]="item.tile"></app-tile-icon>
          </span>
          {{ item.tile.name }}
        </div>
      </ng-template>
    </p-menu>

    <label
      class="form-label d-block mt-3"
      i18n="@@mandantAdminUsersInMandant"
    >Nutzer im Mandanten</label>
    <ul class="list-group mb-2">
      <li
        class="list-group-item d-flex justify-content-between align-items-center"
        *ngFor="let user of mandantUsers"
      >
        <button
          type="button"
          (click)="openUserDialog(user)"
          title="Nutzer bearbeiten"
          i18n-title="@@mandantAdminEditUserTooltip"
          class="btn btn-link p-0 text-start d-flex align-items-center gap-2"
        >
          <span
            class="mandant-admin-badge"
            *ngIf="user.permissions.includes('admin')"
            title="Mandanten-Admin"
            i18n-title="@@mandantAdminUserIsMandantAdminTooltip"
          ><i class="ri-vip-crown-2-fill"></i></span>
          {{ user.globalUser.name }} ({{ user.globalUser.email }})<app-test-user-badge
            [email]="user.globalUser.email"></app-test-user-badge>
        </button>
        <button
          pButton
          type="button"
          [text]="true"
          severity="danger"
          title="Aus Mandant entfernen"
          i18n-title="@@mandantAdminRemoveUserTooltip"
          (click)="removeUserFromMandant(editMandant, user)"
        ><i class="ri-close-line"></i></button>
      </li>
      <li
        class="list-group-item text-muted small"
        *ngIf="mandantUsers.length === 0"
        i18n="@@mandantAdminUsersInMandantEmpty"
      >Noch keine Nutzer in diesem Mandanten.</li>
    </ul>

    <label
      class="form-label d-block mt-3"
      i18n="@@mandantAdminAddUser"
    >Nutzer hinzufügen</label>
    <div class="row g-2 align-items-end mb-3">
      <div class="col-7">
        <ng-select
          #userSelect
          class="form-control p-0 border-0"
          [items]="userOptions"
          bindLabel="email"
          [clearable]="true"
          [(ngModel)]="selectedUserOption"
          [addTag]="createNewUserOption"
          addTagText="Neu anlegen: "
          i18n-addTagText="@@mandantAdminAddUserNewTag"
          placeholder="Bestehenden Nutzer wählen oder neue Adresse eingeben"
          i18n-placeholder="@@mandantAdminAddUserPlaceholder"
          notFoundText="Kein bestehender Nutzer gefunden - Enter für neuen Nutzer"
          i18n-notFoundText="@@mandantAdminAddUserNotFound"
          (open)="disableAutofillOnUserSelect()"
        >
          <ng-template
            ng-option-tmp
            let-item="item"
          >
            <span *ngIf="!item.isNew">{{ item.name }} ({{ item.email }})<app-test-user-badge
                [email]="item.email"></app-test-user-badge></span>
            <span
              *ngIf="item.isNew"
              i18n="@@mandantAdminAddUserNewOption"
            >Neu: {{ item.email }}</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-3">
        <input
          *ngIf="selectedUserOption?.isNew"
          type="text"
          class="form-control form-control-sm"
          placeholder="Name"
          i18n-placeholder="@@globalName"
          [(ngModel)]="newMandantUserName"
        />
      </div>
      <div class="col-2">
        <button
          pButton
          type="button"
          [outlined]="true"
          class="w-100"
          [disabled]="!selectedUserOption || (selectedUserOption.isNew && !newMandantUserName.trim())"
          (click)="addUserToMandant(editMandant)"
          i18n="@@add"
        >Hinzufügen</button>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div
      class="d-flex gap-2 justify-content-start"
      *ngIf="editMandant"
    >
      <button
        pButton
        type="button"
        [outlined]="true"
        (click)="editMandantDrawer.close($event)"
        i18n="@@cancel"
      >Abbrechen</button>
      <button
        pButton
        type="button"
        [disabled]="!!editFormRef?.form?.invalid || !hasMandantChanges() || mandantSaving"
        [loading]="mandantSaving"
        [severity]="mandantSaveFeedback === 'saved' ? 'success' : undefined"
        (click)="editFormRef?.onSubmit()"
      >
        <i
          *ngIf="mandantSaveFeedback === 'saved'"
          class="ri-check-line me-1"
        ></i>
        <span
          *ngIf="mandantSaveFeedback !== 'saved'"
          i18n="@@save"
        >Speichern</span>
        <span
          *ngIf="mandantSaveFeedback === 'saved'"
          i18n="@@globalSavedShort"
        >Gespeichert</span>
      </button>
    </div>
  </ng-template>
</p-drawer>

<p-drawer
  #createMandantDrawer
  [(visible)]="createVisible"
  position="right"
  [style]="{width: 'min(880px, 95vw)'}"
  (onHide)="closeCreateMandant()"
>
  <ng-template #header>
    <span
      class="fs-6 fw-bold"
      i18n="@@globalCreate"
    >Erstellen</span>
  </ng-template>
  <div *ngIf="newMandant">
    <app-form
      #formNew
      type="create"
      [data]="newMandant"
      [showActions]="false"
      [formFields]="[
        { fieldName: 'name', type: 'text', required: true},
        { fieldName: 'short', type: 'text', required: true},
        { fieldName: 'internal', type: 'switch'}
      ]"
      [translatedLabels]="translatedLabels"
      (submit)="createMandant($event)"
    >
    </app-form>

    <label class="form-label d-block">{{ getColumnLabel('tiles') }}</label>
    <ul class="list-group mb-2">
      <li
        class="list-group-item d-flex justify-content-between align-items-center"
        *ngFor="let tile of getAssignedTiles(newMandant)"
      >
        <span class="d-flex align-items-center gap-2">
          <span
            class="tile-admin-table-icon-badge"
            [ngStyle]="{'background-color': tile.color ?? '#6366f1'}"
          >
            <app-tile-icon [tile]="tile"></app-tile-icon>
          </span>
          {{ tile.name }}
        </span>
        <button
          pButton
          type="button"
          [text]="true"
          severity="danger"
          (click)="removeTileFromMandant(newMandant, tile._id)"
          title="Aus dem Kachel-Pool entfernen"
          i18n-title="@@mandantAdminTilesRemoveTooltip"
        ><i class="ri-close-line"></i></button>
      </li>
      <li
        class="list-group-item text-muted small"
        *ngIf="newMandant.tiles.length === 0"
        i18n="@@mandantAdminTilesEmpty"
      >Der Kachel-Pool ist leer.</li>
    </ul>
    <button
      pButton
      type="button"
      [outlined]="true"
      class="mb-3"
      (click)="createTileMenu.toggle($event)"
      title="Zum Kachel-Pool hinzufügen"
      i18n-title="@@mandantAdminTilesAddTooltip"
    ><i class="ri-add-line"></i></button>
    <p-menu
      #createTileMenu
      [popup]="true"
      [model]="getTileMenuItems(newMandant)"
      appendTo="body"
    >
      <ng-template
        #item
        let-item
      >
        <div class="d-flex align-items-center gap-2 px-3 py-2">
          <span
            class="tile-admin-table-icon-badge"
            [ngStyle]="{'background-color': item.tile.color ?? '#6366f1'}"
          >
            <app-tile-icon [tile]="item.tile"></app-tile-icon>
          </span>
          {{ item.tile.name }}
        </div>
      </ng-template>
    </p-menu>
  </div>
  <ng-template #footer>
    <div
      class="d-flex gap-2 justify-content-start"
      *ngIf="newMandant"
    >
      <button
        pButton
        type="button"
        [outlined]="true"
        (click)="createMandantDrawer.close($event)"
        i18n="@@cancel"
      >Abbrechen</button>
      <button
        pButton
        type="button"
        [disabled]="!!formNew?.form?.invalid || createMandantSaving"
        [loading]="createMandantSaving"
        [severity]="createMandantSaveFeedback === 'saved' ? 'success' : undefined"
        (click)="formNew?.onSubmit()"
      >
        <i
          *ngIf="createMandantSaveFeedback === 'saved'"
          class="ri-check-line me-1"
        ></i>
        <span
          *ngIf="createMandantSaveFeedback !== 'saved'"
          i18n="@@save"
        >Speichern</span>
        <span
          *ngIf="createMandantSaveFeedback === 'saved'"
          i18n="@@globalSavedShort"
        >Gespeichert</span>
      </button>
    </div>
  </ng-template>
</p-drawer>